module.exports = __webpack_public_path__ + "img/multiplier_16_win.6a4d7ad3.png";